import PropTypes from "prop-types";
import { STEP_STORAGE_KEYS } from "../constants/storageConstants";
import {
  ANALYSIS_TYPES,
  INTX_TYPES,
  NO_CURRENT_INTERSECTION,
} from "../constants/intxConstants";
import { SafetyFacilityType } from "../calculations/safety/SPFConstants";

export const intersectionDetailsPropType = PropTypes.shape({
  delay: PropTypes.shape({
    openingYear: PropTypes.object,
    designYear: PropTypes.object,
    intersection1: PropTypes.shape({
      openingYear: PropTypes.object,
      designYear: PropTypes.object,
    }),
    intersection2: PropTypes.shape({
      openingYear: PropTypes.object,
      designYear: PropTypes.object,
    }),
  }),
  costParameters: PropTypes.shape({
    designCost: PropTypes.number.isRequired,
    constructionCost: PropTypes.number.isRequired,
    rightOfWayCost: PropTypes.number.isRequired,
    operationsAndMaintenanceCost: PropTypes.object,
  }),
  safety: PropTypes.object,
  // @tianxin you can add to the propType definition when the lane config and orientation are
  // ready to be added to the intersection objects
  //
  // laneConfigInputs - to be added later
  // intersectionOrientation - to be added later
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  uniqueName: PropTypes.string.isRequired,
});

const rampTerminalIntersectionDetailsPropType = PropTypes.shape({
  intersection1: intersectionDetailsPropType,
  intersection2: intersectionDetailsPropType,
});

export const intersectionsPropType = PropTypes.oneOfType([
  PropTypes.arrayOf(intersectionDetailsPropType),
  PropTypes.arrayOf(rampTerminalIntersectionDetailsPropType),
]);

export const projectDataPropType = PropTypes.shape({
  [STEP_STORAGE_KEYS.COST_PARAMETERS_DEFAULTS]: PropTypes.object,
  [STEP_STORAGE_KEYS.CRASH_MODIFICATION_FACTORS]: PropTypes.object,
  [STEP_STORAGE_KEYS.GLOBAL_INPUT_DATA]: PropTypes.object,
  [STEP_STORAGE_KEYS.GLOBAL_SAFETY_DATA]: PropTypes.object,
  [STEP_STORAGE_KEYS.INTERSECTIONS]: intersectionsPropType,
  [STEP_STORAGE_KEYS.PROJECT_INFORMATION]: PropTypes.object,
  [STEP_STORAGE_KEYS.TRAFFIC_VOLUMES]: PropTypes.object,
});

export const analysisTypePropType = PropTypes.oneOf(
  Object.values(ANALYSIS_TYPES)
);

export const stringOrNumberPropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

export const optionPropType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: stringOrNumberPropType.isRequired,
});
export const optionsPropType = PropTypes.arrayOf(optionPropType);

export const intxTypePropType = PropTypes.oneOf(Object.values(INTX_TYPES));
export const currentIntxPropType = PropTypes.oneOf([
  ...Object.values(INTX_TYPES),
  NO_CURRENT_INTERSECTION,
]);
export const safetyFacilityTypePropType = PropTypes.oneOf(
  Object.values(SafetyFacilityType)
);
